import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useGlobalModalStore } from '@/stores/useGlobalModalStore/useGlobalModalStore'
import { RenameReportContent } from '@/components/molecules/RenameReportContent/RenameReportContent'
import { GetReportResponse } from '@/hooks'

export const useRenameReport = () => {
    const { t } = useTranslation('translations')
    const setModalState = useGlobalModalStore((state) => state.setModalState)

    const closeModal = useCallback(() => {
        setModalState({ isOpen: false })
    }, [setModalState])

    const openRenameReportModal = useCallback(
        (report: GetReportResponse, handleOnSuccess?: () => void) => {
            setModalState({
                isOpen: true,
                title: t('reporting.rename_report.title'),
                content: () => (
                    <RenameReportContent
                        report={report}
                        handleOnSuccess={handleOnSuccess}
                    />
                ),
                onClose: closeModal,
            })
        },
        [setModalState, t, closeModal]
    )

    return {
        openRenameReportModal,
        closeRenameReportModal: closeModal,
    }
}
